var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "root" }, [
      _c("div", { staticClass: "stripe" }, [
        _vm._v("\n    CUPOM LIBERADO!\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("img", { attrs: { src: "static/dashboard/discount.svg" } }),
        _vm._v(" "),
        _c("div", { staticClass: "discount" }, [
          _vm._v(
            "\n      Começando a semana com aquela baguncinha para organizar?"
          ),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n      Não se preocupe, a Donamaid separou uma super oferta para você garantir aquela ajuda com as tarefas 💜 "
          ),
          _c("br"),
          _c("br"),
          _vm._v("\n      Utilize o cupom "),
          _c("b", [_vm._v("10DESC")]),
          _vm._v(" e garanta "),
          _c("b", { staticClass: "discount-amount" }, [
            _vm._v("10% de desconto")
          ]),
          _vm._v(" nas suas próximas limpezas.\n\n      "),
          _c("div", { staticClass: "restriction" }, [
            _vm._v(
              "\n        O cupom é válido até às 12h desta quarta-feira, 09/11 e pode ser aplicado em limpezas que serão realizadas até o dia 09/11. Desconto limitado a R$10 por limpeza. Não cumulativo com outros cupons.\n      "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63558538", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63558538","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banners/BannerSuperPromo.vue
// module id = null
// module chunks = 